// extracted by mini-css-extract-plugin
export var dropdownContainer = "_5f-5";
export var imageContainer = "_5f-4";
export var metricsGrid = "_5f-2";
export var productDetailContainer = "_5f-1";
export var productListContainer = "_5f-0";
export var subscriberTableContainer = "_5f-3";